// A UI dismissal scope, never an authentication credential.
const memory = new Map<number, string>();
export function readPromotion(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}
export function writePromotion(key: string, value: string) {
  try { localStorage.setItem(key, value); } catch { /* Keep this session usable. */ }
}
export function promotionSession(userId: number, begin = false): string {
  const key = `promotion_login_session_${userId}`;
  const existing = readPromotion(key) || memory.get(userId);
  if (!begin && existing) return existing;
  const session = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  memory.set(userId, session);
  writePromotion(key, session);
  return session;
}
export function isFreePromotionAccount(user: { current_plan_id?: number; lifetime_plan?: boolean } | null) {
  return !!user && !user.lifetime_plan && (user.current_plan_id == null || user.current_plan_id === 1);
}
